/* PlayShop — Calendrier des sorties (Phase A : rendu client depuis l'edge fn release-calendar).
   Vue Timeline (défaut) + Grille mensuelle, filtres type/année, dépliage produits, JSON-LD. */
(function () {
  var root = document.querySelector('[data-ps-cal]');
  if (!root) return;
  var licence = root.dataset.licence || 'pokemon';
  var assetBase = root.dataset.assetBase || '';
  var body = root.querySelector('[data-ps-cal-body]');
  var controls = root.querySelector('[data-ps-cal-controls]');
  var selType = root.querySelector('[data-ps-cal-filter-type]');
  var selYear = root.querySelector('[data-ps-cal-filter-year]');
  var FN = 'https://ipvzpgwgujamtzztxvcu.supabase.co/functions/v1/release-calendar?licence=' + encodeURIComponent(licence);

  var MONTHS = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];
  var MONTHS_SHORT = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
  var DOW = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];

  var DATA = null, fType = '', fYear = ''; // vue unique : timeline

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function logoUrl(r) { if (!r.logo) return null; return r.logoIsUrl ? r.logo : (assetBase + r.logo); }
  // Fallback image en cascade : logo set → (si 404) image produit → (sinon) initiales.
  window.psCalImgErr = function (img) {
    var fb = img.getAttribute('data-fb');
    if (fb && img.getAttribute('data-tried') !== '1') { img.setAttribute('data-tried', '1'); img.classList.add('is-prod'); img.src = fb; return; }
    var sp = document.createElement('span'); sp.className = 'ps-cal-rel__ini'; sp.textContent = img.getAttribute('data-ini') || '?';
    img.replaceWith(sp);
  };
  function initials(name) { return String(name || '?').replace(/[^A-Za-zÀ-ÿ0-9 ]/g, '').trim().split(/\s+/).slice(0, 2).map(function (w) { return w[0]; }).join('').toUpperCase() || '?'; }
  function previewImg(u) { if (!u) return ''; var s = u.indexOf('//') === 0 ? 'https:' + u : u; if (/cdn\.shopify|\/cdn\//.test(s) && !/[?&]width=/.test(s)) s += (s.indexOf('?') >= 0 ? '&' : '?') + 'width=420'; return s; }
  // Miniature légère : sur les images Shopify CDN (produits), on demande une version redimensionnée (perf).
  // Les logos de set (assets du thème) ne se redimensionnent pas par URL → renvoyés tels quels.
  function thumb(u, w) { if (!u) return u; var s = u.indexOf('//') === 0 ? 'https:' + u : u; if (/cdn\.shopify|\/cdn\//.test(s) && !/[?&]width=/.test(s)) s += (s.indexOf('?') >= 0 ? '&' : '?') + 'width=' + (w || 160); return s; }
  function statusInfo(r) {
    if (r.status === 'upcoming') return { cls: 'soon', label: (r.date && new Date(r.date) - new Date() > 0 ? 'À venir' : 'À venir') };
    if (r.status === 'undated') return { cls: 'undated', label: 'Date à confirmer' };
    return { cls: 'out', label: 'Disponible' };
  }
  function all() { return [].concat(DATA.upcoming || [], DATA.past || [], DATA.undated || []); }
  function pass(r) { return (!fType || (r.types || []).indexOf(fType) >= 0) && (!fYear || String(r.year) === fYear); }

  /* ---------- carte release ---------- */
  function relCard(r) {
    var st = statusInfo(r);
    var url = null, isProductImg = false;
    if (fType && r.products) { // filtre type actif → image du PRODUIT correspondant (ex. l'ETB)
      var mp = r.products.filter(function (p) { return p.type === fType && p.image; })[0];
      if (mp) { url = mp.image; isProductImg = true; }
    }
    if (!url) url = logoUrl(r); // logo de set (URL du site)
    if (!url && r.products) { // sinon image du 1er produit (URL du site)
      var pImg = r.products.map(function (p) { return p.image; }).filter(Boolean)[0];
      if (pImg) { url = pImg; isProductImg = true; }
    }
    var prodFb = isProductImg ? '' : ((r.products || []).map(function (p) { return p.image; }).filter(Boolean)[0] || '');
    var ini = initials(r.setName);
    var logoHtml = url
      ? '<img class="' + (isProductImg ? 'is-prod' : '') + '" src="' + esc(thumb(url, 160)) + '" alt="' + esc(r.setName) + '" loading="lazy" decoding="async" data-ini="' + esc(ini) + '" data-fb="' + esc(thumb(prodFb, 160)) + '" onerror="psCalImgErr(this)" />'
      : '<span class="ps-cal-rel__ini">' + esc(ini) + '</span>';
    var dateHtml = r.date
      ? '<span class="d">' + (+r.date.slice(8, 10)) + '</span><span class="m">' + MONTHS_SHORT[+r.date.slice(5, 7) - 1] + '</span><span class="y">' + r.date.slice(0, 4) + '</span>'
      : '<span class="m">' + esc(r.dateDisplay || '?') + '</span>';
    var meta = [];
    if (r.totalCards) meta.push(r.totalCards + ' cartes');
    if (r.productCount) meta.push(r.productCount + ' produit' + (r.productCount > 1 ? 's' : ''));
    var prodHtml = '';
    if (r.products && r.products.length) {
      prodHtml = '<ul class="ps-cal-rel__prods">' + r.products.map(function (p) {
        var price = p.price != null ? '<span class="px">' + p.price.toFixed(2).replace('.', ',') + ' €</span>' : '';
        var tlabel = (p.typeLabel || p.type || '') + (p.variant ? ' · ' + p.variant : '');
        var nm = esc(p.name) + (p.variantCount > 1 ? ' <span class="ps-cal-rel__vc">' + p.variantCount + ' modèles</span>' : '');
        var th = p.image
          ? '<img class="ps-cal-rel__thumb" src="' + esc(thumb(p.image, 72)) + '" alt="" loading="lazy" decoding="async" />'
          : '<span class="ps-cal-rel__thumb ps-cal-rel__thumb--ph" aria-hidden="true"></span>';
        var inner = th + '<span class="t">' + esc(tlabel) + '</span><span class="n">' + nm + '</span>' + price;
        var pv = previewImg(p.image);
        var hov = pv ? ' data-ps-card-img="' + esc(pv) + '"' : (p.handle ? ' data-ps-card-handle="' + esc(p.handle) + '"' : '');
        return '<li>' + (p.url ? '<a href="' + esc(p.url) + '"' + hov + '>' + inner + '</a>' : '<span' + hov + '>' + inner + '</span>') + '</li>';
      }).join('') + '</ul>';
    }
    var openable = !!prodHtml;
    // Lien vers les cartes (singles) du set — collectionHandle = collection du set.
    var cardsUrl = r.collectionHandle ? '/collections/' + r.collectionHandle : '';
    // Set/série (a une collection de cartes ou un total de cartes) vs produit solo → styles distincts.
    var isSet = !!(r.collectionHandle || r.totalCards);
    var logoBlock = cardsUrl
      ? '<a class="ps-cal-rel__logo ps-cal-rel__logolink" href="' + esc(cardsUrl) + '" aria-label="Voir les cartes ' + esc(r.setName) + '">' + logoHtml + '</a>'
      : '<div class="ps-cal-rel__logo">' + logoHtml + '</div>';
    var nameBlock = cardsUrl
      ? '<a href="' + esc(cardsUrl) + '">' + esc(r.setName) + '</a>'
      : esc(r.setName);
    var actions = (openable || cardsUrl)
      ? '<div class="ps-cal-rel__actions">' +
          (cardsUrl ? '<a class="ps-cal-rel__cards" href="' + esc(cardsUrl) + '">Cartes</a>' : '') +
          (openable ? '<button type="button" class="ps-cal-rel__toggle" aria-expanded="false">Produits</button>' : '') +
        '</div>'
      : '';
    return '<article class="ps-cal-rel ps-cal-rel--' + st.cls + (isSet ? ' ps-cal-rel--set' : '') + '" style="--c:' + esc(r.color || (isSet ? '#1A22DD' : '#6f8bff')) + '">' +
      '<div class="ps-cal-rel__date">' + dateHtml + '</div>' +
      logoBlock +
      '<div class="ps-cal-rel__main">' +
        '<h3 class="ps-cal-rel__name">' + nameBlock + '</h3>' +
        '<div class="ps-cal-rel__meta"><span class="ps-cal-rel__badge ps-cal-rel__badge--' + st.cls + '">' + st.label + '</span>' +
          (meta.length ? '<span class="ps-cal-rel__dim">' + meta.join(' · ') + '</span>' : '') + '</div>' +
      '</div>' +
      actions +
      (openable ? '<div class="ps-cal-rel__drawer" hidden>' + prodHtml + '</div>' : '') +
    '</article>';
  }

  /* ---------- vue timeline ---------- */
  function renderTimeline() {
    var up = (DATA.upcoming || []).filter(pass);
    var past = (DATA.past || []).filter(pass);
    var und = (DATA.undated || []).filter(pass);
    var h = '';
    if (up.length) {
      h += '<section class="ps-cal-group ps-cal-group--up"><h2 class="ps-cal-group__title">🔜 À venir &amp; précommandes</h2><div class="ps-cal-rels">' + up.map(relCard).join('') + '</div></section>';
    }
    // passées groupées par année
    var byYear = {};
    past.forEach(function (r) { (byYear[r.year] = byYear[r.year] || []).push(r); });
    var years = Object.keys(byYear).map(Number).sort(function (a, b) { return b - a; });
    if (years.length) {
      h += '<section class="ps-cal-group"><h2 class="ps-cal-group__title">📅 Sorties passées</h2>';
      years.forEach(function (y, i) {
        var open = i < 2 ? ' open' : '';
        h += '<details class="ps-cal-year"' + open + '><summary>' + y + ' <span class="ps-cal-year__n">' + byYear[y].length + '</span></summary>' +
          '<div class="ps-cal-rels">' + byYear[y].map(relCard).join('') + '</div></details>';
      });
      h += '</section>';
    }
    if (und.length) {
      h += '<section class="ps-cal-group"><details class="ps-cal-year"><summary>❔ Date à confirmer <span class="ps-cal-year__n">' + und.length + '</span></summary><div class="ps-cal-rels">' + und.map(relCard).join('') + '</div></details></section>';
    }
    if (!up.length && !past.length && !und.length) h = '<p class="ps-cal-empty">Aucune sortie pour ce filtre.</p>';
    body.innerHTML = h;
  }

  function render() { renderTimeline(); }

  /* ---------- filtres + JSON-LD ---------- */
  function populateFilters() {
    var types = {}, years = {};
    all().forEach(function (r) { (r.types || []).forEach(function (t) { types[t] = (r.products || []).reduce(function (acc, p) { return p.type === t ? (p.typeLabel || t) : acc; }, types[t] || t); }); if (r.year) years[r.year] = 1; });
    Object.keys(types).sort().forEach(function (t) { var o = document.createElement('option'); o.value = t; o.textContent = types[t]; selType.appendChild(o); });
    Object.keys(years).map(Number).sort(function (a, b) { return b - a; }).forEach(function (y) { var o = document.createElement('option'); o.value = y; o.textContent = y; selYear.appendChild(o); });
  }
  function jsonLd() {
    var items = [].concat(DATA.upcoming || [], DATA.past || []).filter(function (r) { return r.date; }).slice(0, 200);
    var el = root.querySelector('[data-ps-cal-jsonld]');
    if (!el) return;
    el.textContent = JSON.stringify({
      '@context': 'https://schema.org', '@type': 'ItemList',
      name: 'Calendrier des sorties ' + licence, numberOfItems: items.length,
      itemListElement: items.map(function (r, i) {
        return { '@type': 'ListItem', position: i + 1, item: { '@type': 'Product', name: r.setName, releaseDate: r.date, category: licence, image: logoUrl(r) || undefined, url: r.collectionHandle ? ('https://playshop.fr/collections/' + r.collectionHandle) : undefined } };
      })
    });
  }

  /* ---------- events ---------- */
  selType.addEventListener('change', function () { fType = selType.value; render(); });
  selYear.addEventListener('change', function () { fYear = selYear.value; render(); });
  body.addEventListener('click', function (e) {
    var tg = e.target.closest('.ps-cal-rel__toggle');
    if (tg) { var rel = tg.closest('.ps-cal-rel'); var dr = rel && rel.querySelector('.ps-cal-rel__drawer'); if (!dr) return; var open = dr.hasAttribute('hidden'); if (open) dr.removeAttribute('hidden'); else dr.setAttribute('hidden', ''); tg.setAttribute('aria-expanded', open); tg.classList.toggle('is-open', open); return; }
  });

  /* ---------- init ---------- */
  // Anti-flash : le body contient le SSR (rendu robots/SEO). Pour les vrais utilisateurs, on le
  // remplace IMMÉDIATEMENT par un skeleton propre → on ne voit jamais l'ancienne liste pendant le fetch.
  // Le SSR est conservé en fallback : réaffiché si le fetch échoue (résilience + robots sans JS).
  var SSR_HTML = body.innerHTML;
  function skeleton() { var row = '<div class="ps-cal-skel__row"></div>'; return '<div class="ps-cal-skel" aria-hidden="true">' + new Array(8).join(row) + '</div>'; }
  body.innerHTML = skeleton();
  fetch(FN + '&v=' + Math.floor(Date.now() / 120000)).then(function (r) { return r.json(); }).then(function (d) {
    DATA = d; controls.hidden = false; populateFilters(); render();
  }).catch(function () { body.innerHTML = SSR_HTML; /* fetch KO → on remet le SSR */ });
})();
